import request from '@/utils/request'


/**
 * 公司注册
 * @param query
 */
export function register(query) {
  return request({
    url: '/api/company/register',
    method: 'post',
    data: query || {}
  })
}
/**
 * 公司列表
 * @param query
 */
export function fetchList(query) {
  return request({
    url: '/api/company/list',
    method: 'post',
    data: query || {}
  })
}

/**
 * 查询所有公司
 * @param query
 */
export function findAllList() {
  return request({
    url: '/api/company/all',
    method: 'post'
  })
}

/**
 * 删除公司
 * @param param
 */
export function remove(param) {
  return request({
    url: '/api/company/delete/' + param,
    method: 'get'
  })
}
/**
 * 审核公司
 * @param param
 */
export function doAudit(param) {
  return request({
    url: '/api/company/audit/' + param,
    method: 'post'
  })
}

/**
 * 获取单个试卷信息
 * @param param
 */
export function get(param) {
  return request({
    url: '/api/company/get/' + param,
    method: 'get'
  })
}

/**
 * 保存公司
 * @param param
 */
export function save(param) {
  return request({
    url: '/api/company/save',
    method: 'post',
    data: param
  })
}

/**
 * 修改试卷
 * @param param
 */
export function update(param) {
  return request({
    url: '/api/company/update',
    method: 'post',
    data: param
  })
}

/**
 *  查询当前公司下的所有方案
 * @param param
 */
export function findSchemeByUserId(userId) {
  return request({
    url: '/api/company/' + userId + '/list',
    method: 'get'
  })
}

/**
 *  查询当前公司下的所有项目
 * @param param
 */
export function getCompanyProjectList(query) {
  return request({
    url: '/api/project/list/' + query.userId,
    method: 'post',
    data: query
  })
}

/**
 *  获取项目所使用的方案
 * @param param
 */
export function getSchemeByProjectId(projectId) {
  return request({
    url: `/api/scheme/project/${projectId}`,
    method: 'get'
  })
}

/**
 *  获取标准项目的报告列表
 * @param param
 */
export function getStandardReport(projectId,query) {
  return request({
    url: `/api/report/list/${projectId}`,
    method: 'post',
    data: query||{}
  })
}
/**
 *  获取标准项目的报告列表
 * @param param
 */
export function findReporpList(projectId) {
  return request({
    url: `/api/report/all/${projectId}`,
    method: 'post',
  })
}

/**
 *  获取项目 个人方案 列表
 * @param param
 */
export function getPersonScheme(projectId) {
  return request({
    url: '/api/paper/project/' + projectId,
    method: 'get'
  })
}

/**
 *  获取项目 个人方案 试卷下的报告
 * @param param
 */
export function getPersonReport(projectId,paperId,query) {
  return request({
    url: `/api/record/list/${projectId}/${paperId}`,
    method: 'post',
    data: query||{}
  })
}

/**
 * 删除测评未做完人员
 *
 * */
export function deleteUser(userId) {
  return request({
    url: '/api/report/delete/' + userId,
    method: 'get',
  })
}

/**
 * 修改人员信息
 *
 * */
export function editUser(projectId,userId,query) {
  return request({
    url: `/api/report/update/user/info/${projectId}/${userId}`,
    method: 'post',
    data: query || {}
  })
}

/**
 * 查询测评人数
 *
 * */
export function getEvUserNum(companyId) {
  return request({
    url: `/api/report/count/${companyId}`,
    method: 'post',
  })
}

/**
 * 查询测评人数
 *
 * */
export function countByMouth(companyId) {
  return request({
    url: `/api/report/count/mouth/${companyId}`,
    method: 'post',
  })
}

/**
 * 获取项目的人数情况
 * */
export function getProjectUserNum (porjectId) {
  return request({
    url:'/api/report/info/' + porjectId,
    method:'post'
  })
}
